export default defineNuxtPlugin(() => {
  return {
    parallel: true,
    provide: {
      capitalizeFirstLetter: (string: string) =>
        string.charAt(0).toUpperCase() + string.slice(1),
    },
  }
})
